import { CertificateStatus } from 'src/types/TaxExemptionCertificate';

export enum StatusColors {
  GREEN = '#CDEDD5',
  YELLOW = '#FFDCB1',
  RED = '#FFC7CA',
  GREY = '#EFEFF2',
  WHITE = '#FFFFFF',
}
// These color comes directly from the design doc:
// https://www.figma.com/file/l8qPb4HUjkADqR62dwXFu7/DC-4877-Exemption-status-and-expiration?node-id=114%3A10517
// They are not Cookbook officially colors (http://cookbook-web-react.ghbeta.com/?path=/docs/core-theme-colors--main-story)

export const colorForStatus = (status: CertificateStatus): string => {
  switch (status) {
    case CertificateStatus.CURRENT:
      return StatusColors.GREEN;
    case CertificateStatus.EXPIRING:
      return StatusColors.YELLOW;
    case CertificateStatus.REJECTED:
    case CertificateStatus.EXPIRED:
      return StatusColors.RED;
    case CertificateStatus.RENEWED:
    case CertificateStatus.UNTRACKED:
      return StatusColors.GREY;
    default:
      return StatusColors.WHITE;
  }
};
